export const EDUCATION = {
  name: 'Education',
  value: 'EDUCATION',
};

export const NON_EDUCATION = {
  name: 'Non Education',
  value: 'NON_EDUCATION',
};

export const MIXED = {
  name: 'Mixed',
  value: 'MIXED',
};

const Basic = [EDUCATION, NON_EDUCATION, MIXED];

const BasicByValue = Basic.reduce((hash, status) => {
  hash[status.value] = status;
  return hash;
}, {});

const BasicValues = Object.keys(BasicByValue);

export default {
  Basic,
  BasicByValue,
  BasicValues,

  EDUCATION,
  NON_EDUCATION,
  MIXED,
};
